import { render, staticRenderFns } from "./LandingPageChatSection.vue?vue&type=template&id=1f61ad40&scoped=true"
import script from "./LandingPageChatSection.vue?vue&type=script&lang=js"
export * from "./LandingPageChatSection.vue?vue&type=script&lang=js"
import style0 from "./LandingPageChatSection.vue?vue&type=style&index=0&id=1f61ad40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f61ad40",
  null
  
)

export default component.exports